module.exports = __webpack_public_path__ + "static/video1_Webm-bb1c960da6a7df0bcb0a5990384adaf8.webm";